import { GENERATE_URL } from "@services/helpers/request";
export const GetSummary = (options) =>
  GENERATE_URL("/CrmSaleReport/Summary", options);
export const GetDetails = (options) =>
  GENERATE_URL("/CrmSaleReport/Details", options);
export const GetBrandSummary = (options) =>
  GENERATE_URL("/CrmSaleReport/BrandSummary", options);
export default { GetSummary, GetDetails, GetBrandSummary };
